document.addEventListener('click', (e) => {
  const btn = e.target.closest('.news-grid__load-more');
  if (!btn) return;

  const grid = btn.closest('.wp-block-buttons').previousElementSibling;
  const offset = parseInt(btn.dataset.offset, 10);
  const perPage = parseInt(btn.dataset.perPage, 10);
  const postType = btn.dataset.postType || 'news';

  btn.disabled = true;

  const body = new URLSearchParams({
    action: newsGridAjax.action,
    offset,
    per_page: perPage,
    post_type: postType,
  });

  fetch(newsGridAjax.ajax_url, { method: 'POST', body })
    .then((r) => r.json())
    .then((data) => {
      if (!data.result) {
        console.error('news-grid load more error:', data.msg);
        btn.disabled = false;
        return;
      }

      grid.insertAdjacentHTML('beforeend', data.html);
      btn.dataset.offset = offset + perPage;

      if (!data.has_more) {
        btn.remove();
      } else {
        btn.disabled = false;
      }
    })
    .catch((err) => {
      console.error('news-grid AJAX failed:', err);
      btn.disabled = false;
    });
});
